import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config/config.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { TourProgress } from '../../models/tour-progress';
import { TourProgressUpsertRequest } from '../../models/tour-progress-request';

/**
 * Both calls are scoped to the signed-in user by the API, which reads the owning user from the
 * access token. Neither takes a user id.
 *
 * Both opt out of the global error handler. Tours are cosmetic onboarding, and the GET fires
 * automatically on every login — without this, a 500 or a network blip would dispatch setGlobalError
 * and navigate the patient to /error over a tour tooltip. The store fails closed on load errors and
 * rolls back optimistic writes on upsert errors, so a swallowed failure degrades to "no tour this
 * session" rather than a broken page.
 */
@Injectable({
  providedIn: 'root',
})
export class TourProgressService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  tourProgressEndpoint = `${this.config.patientApiUrl}/v1/PatientPortal/UserTourProgress`;

  getTourProgress(): Observable<TourProgress[]> {
    return this.utilityService.getRequest<TourProgress[]>(this.tourProgressEndpoint, { skipGlobalError: true });
  }

  upsert(request: TourProgressUpsertRequest): Observable<TourProgress> {
    return this.utilityService.putRequest<TourProgress>(this.tourProgressEndpoint, request, { skipGlobalError: true });
  }
}
